export const mentorsData = [

    {
      mentorName: "Krillin",
      mentorDescription:
        "Krillin, Earth's strongest human, focuses on agility, cardio, and core strength. His training is designed for those who want to enhance speed and endurance while maintaining a solid core.",
      mentorExercises: ["Jump Rope", "Burpees", "Russian Twists"],
      mentorImg: "https://firebasestorage.googleapis.com/v0/b/fitpowerup-2bbc8.appspot.com/o/assets%2Fskill-tree-images%2Fkrillin.webp?alt=media&token=29fc4aaa-78c0-43b4-b297-ccb87de77f46", // Replace with actual image path or URL
    },  
  ];